import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { savingsEasyConfig } from '../../../environments/environment';
import { LoginService } from '../../service/login.service';

@Component({
    selector: 'app-saving-easy',
    template: ''
})
export class SavingEasyComponent implements OnInit {
  constructor(
    private loginService: LoginService,
    private route: ActivatedRoute
  ) {
      this.route.url.subscribe((segments) => {
          let native = segments.some((seg) => seg.path === 'native');
          this.route.queryParams.subscribe(async (params) => {
            const inApp = params['inApp'];
            const product = params['product'];
            const banner = params['banner'];
            let channel = params['channel'];
    
            const tenanthost = params['tenanthost'];
            if (tenanthost === 'eb') {
              channel = 'ebanking';
            } else {
              channel = 'app';
            }
    
            if (savingsEasyConfig.redirectUri) {
              // Handle native path
              if (native) {
                savingsEasyConfig.redirectUri += '/native';
              }
    
              // Build query parameters
              const queryParams = [];
    
              if (banner) {
                queryParams.push('banner=' + banner);
              }
    
              if (channel) {
                queryParams.push('channel=' + channel);
              }
    
              if (inApp) {
                queryParams.push('inApp=true');
              }
    
              if (product) {
                queryParams.push('product=' + product);
              }
    
              // Append query parameters if any exist
              if (queryParams.length > 0) {
                const separator = savingsEasyConfig.redirectUri.includes('?') ? '&' : '?';
                savingsEasyConfig.redirectUri += separator + queryParams.join('&');
              }
            }
          });
        });
    // this.route.queryParams.subscribe(async (params) => {
    //   const inApp = params['inApp'];
    //   const product = params['product'];

    //   const banner = params['banner'];
    //   let channel = params['channel'];

    //   const tenanthost = params['tenanthost'];
    //   if (tenanthost === 'eb') {
    //     channel = 'ebanking';
    //   }else{
    //     channel = 'app';
    //   }

    //   const queryParams = [];

    //   if (banner) {
    //     queryParams.push('banner=' + banner);
    //   }

    //   if (channel) {
    //     queryParams.push('channel=' + channel);
    //   }

    //   if (inApp) {
    //     queryParams.push('inApp=true');
    //   }

    //   if (product) {
    //     queryParams.push('product=' + product);
    //   }

    //   if (queryParams.length > 0) {
    //     savingsEasyConfig.redirectUri += '?' + queryParams.join('&');
    //   }
    // });
  }

  ngOnInit(): void {
    this.loginService.login(savingsEasyConfig);
  }
}
